import { useBFFWebChatState } from './useBFFWebChatState';
export function useBFFWebChatConfig() {
    const [state] = useBFFWebChatState();
    return state.config;
}
//# sourceMappingURL=useBFFWebChatConfig.js.map